import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { FieldError } from 'react-hook-form';

import DaterangePicker from '../../../../PayoutsScreen/Components/DaterangePicker';

interface DataRangeWrapperProps {
  customStyling?: FlattenSimpleInterpolation;
}

const DataRangeWrapper = styled.div<DataRangeWrapperProps>`
  position: relative;
  display: flex;
  justify-content: space-between;

  ${({ customStyling }) => customStyling};
`;

const DateInput = styled.div`
  width: max-content;
  min-width: 190px;
  height: 50px;

  align-items: center;
  background-color: hsl(0, 0%, 100%);
  border-color: hsl(0, 0%, 80%);
  border-radius: 35px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 0px 3px #c4c4c4;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 100ms;
  box-sizing: border-box;
  border: 0;
  text-align: center;
  padding: 0 10px;
  color: hsl(0, 0%, 50%);
  cursor: default;

  &:hover {
    box-shadow: 0px 0px 15px #c4c4c4;
  }
`;

interface GameEventDaterangePickerProps {
  onChange?(date: [Date | null, Date | null], event?: React.SyntheticEvent<any, Event>): void;

  selectsRange?: boolean;
  startDate: Date | null;
  endDate: Date | null;
  error?: FieldError | any;
  inline?: boolean;
  isClearable?: boolean;
  labelStartDate?: string;
  labelEndDate?: string;
  disabled?: boolean;
  styling?: {
    wrapper?: DataRangeWrapperProps;
  };
  alwaysAsArray?: boolean;
}

export default function GameEventDaterangePicker({
  onChange,
  isClearable,
  labelStartDate,
  labelEndDate,
  startDate,
  endDate,
  disabled,
  error,
  selectsRange,
  alwaysAsArray,
  styling,
}: GameEventDaterangePickerProps) {
  return (
    <DaterangePicker
      isClearable={isClearable}
      startDate={startDate || null}
      endDate={endDate || null}
      selectsRange={selectsRange as any}
      inline={true}
      onChange={onChange}
      alwaysAsArray={alwaysAsArray}
      minDate={new Date()}
      dataInputComponent={(dates, collapsed, isCollapsed) => (
        <DataRangeWrapper {...styling?.wrapper}>
          <DateInput
            onClick={() => {
              if (disabled) return;
              isCollapsed(!collapsed);
            }}
          >
            {dates[0] ? dates[0].toDateString() : labelStartDate}
          </DateInput>
          {selectsRange && (
            <DateInput
              onClick={() => {
                if (disabled) {
                  return;
                }

                isCollapsed(!collapsed);
              }}
            >
              {dates[1] ? dates[1].toDateString() : labelEndDate}
            </DateInput>
          )}
        </DataRangeWrapper>
      )}
      error={error}
    />
  );
}
